import CostHTMLPreviewBaseColumnsStrategy from './CostHTMLPreviewBaseColumnsStrategy'

export default function CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy() {}

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype = new CostHTMLPreviewBaseColumnsStrategy();

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.init = function({timeFormat, showAverageRates, showOthers}) {
    CostHTMLPreviewBaseColumnsStrategy.prototype.init.call(this, timeFormat, false, showAverageRates)
    this.showOthers = showOthers
    return this
}

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.getLevelNameKey = function ()
{
    // abstract
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.getLevelCellsClassName = function ()
{
    // abstract
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function(row) {
    this.addOverallHeaderCells(row)
    for (let i = 0; i < (this.showOthers ? 2 : 3); i++) {
        this.addCell(row, this.message(this.getLevelNameKey()), this.getLevelCellsClassName(), 1, 3)
    }
    if (this.showOthers) this.addCell(row, this.message("report.common.others"), this.getLevelCellsClassName(), 1, 3)
}

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function( row )
{
    // do nothing
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function( row )
{
    // do nothing
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addDataCells = function( row )
{
    this.addOverallDataCells( row );
    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row );
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.getDataColumnsCount = function()
{
    return this.getOverallColumnsCount() + 3;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.js